export default __webpack_public_path__ + "static/media/img3.197775b3.png";